import type { ComponentProps } from 'react';

import * as LabelPrimitive from '@radix-ui/react-label';
import type { VariantProps } from 'tailwind-variants';

import { labelStyles } from './styles/label.style';

export type LabelPrimitiveProps = ComponentProps<typeof LabelPrimitive.Root> &
  VariantProps<typeof labelStyles>;

export function Label({
  className,
  disabled,
  error,
  ...props
}: LabelPrimitiveProps) {
  return (
    <LabelPrimitive.Root
      className={labelStyles({ className, error, disabled })}
      data-slot="label"
      {...props}
    />
  );
}
